import router from "next/router";

const studyTrailPath = (courseSlug: string) => `/courses/${courseSlug}/home`;
const contentPath = (courseSlug: string) => `/courses/${courseSlug}/content`;
const studyProgramPath = (courseSlug: string, studyProgramSlug: string) =>
  `/courses/${courseSlug}/programs/${studyProgramSlug}`;

const redirectToHome = () => {
  router
    .push("/")
    .then(() => null)
    .catch(() => null);
};

const redirectToStudyProgram = (
  courseSlug: string,
  studyProgramSlug: string,
) => {
  const path = studyProgramPath(courseSlug, studyProgramSlug);
  router
    .push(path)
    .then(() => null)
    .catch(() => null);
};

const unitContentPath = (courseSlug: string, programUnitShortSlug: string) => {
  return `/courses/${courseSlug}/units/${programUnitShortSlug}`;
};

const redirectToUnitContent = (
  courseSlug: string,
  programUnitShortSlug: string,
) => {
  const path = unitContentPath(courseSlug, programUnitShortSlug);
  router
    .push(path)
    .then(() => null)
    .catch(() => null);
};

export {
  contentPath,
  studyTrailPath,
  studyProgramPath,
  unitContentPath,
  redirectToHome,
  redirectToStudyProgram,
  redirectToUnitContent,
};
